import mycss from 'src/assets/sass/lbd/_variables.scss'

export const colors = [
    mycss.newBlue,
    mycss.newRed,
    mycss.newOrange,
    mycss.newPurple,
    mycss.newGreen,
    mycss.newDarkBlue,
    mycss.newBlack,
    mycss.socialGoogle,
    mycss.socialTumblr,
    mycss.socialYoutube,
    mycss.socialTwitter,
    mycss.socialPinterest,
    mycss.socialBehance,
    mycss.cuteBlue,
    mycss.cuteMagenta
]

export const formatMoney = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})
export const formatSimple = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    // currency: '',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
})

export const formatSimple2d = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    // currency: '',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
})

export const gitlab_issue_description = "We would like to join forces and have this vendor on the Costs Dashboard"
export const gitlab_issue_url = "https://git.naspersclassifieds.com/static/costs-dashboard/issues/new?issue%5Bassignee_id%5D=&issue%5Bmilestone_id%5D=&issue%5Bdescription%5D=" + gitlab_issue_description + "&issue%5Btitle%5D="

export const chart_base = {
    'options': {
        'seriesBarDistance': 100,
        'seriesBarWidth': 4,
        'axisX': {
            'showGrid': true,
            'showLabel': true
        },
        'height': '245px',
        'chartPadding': {
            'right': 50,
            'left': 50,
            'top': 0,
            'bottom': 10,
        },
        'tooltip': {
            'tooltipFnc': function(meta, value) {
                return (value)
            },

            tooltipOffset: {
                x: 10,
                y: 70
            },
            'appendToBody': false,
            'transformTooltipTextFnc': function(value) {
                return formatSimple.format(value)
            }
        },
    },
    'responsiveOptions': [
        ['screen and (min-width: 1200px) and (max-width: 1450px)', {
            'seriesBarDistance': 5,
            'axisX': {
                labelInterpolationFnc(value) {
                    return value[0] + '' + value.substring(value.length - 2)
                }
            }
        }],
        ['screen and (max-width: 640px)', {
            'seriesBarDistance': 5,
            'axisX': {
                labelInterpolationFnc(value) {
                    return value.substring(0, 3) + '' + value.substring(value.length - 2)
                }
            }
        }],
        ['screen and (max-width: 518px)', {
            'seriesBarDistance': 3,
            'axisX': {
                labelInterpolationFnc(value) {
                    return value[0] + '' + value.substring(value.length - 2)
                }
            }
        }],
    ]
}